import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FormMappersFactory} from '../../form/Mappers/factory.js'
import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DraftRepositoriesFactory} from '../Repositories/factory.js'

class GetEmptyAdAdPublisherUseCase extends UseCase {
  #fromDraftEntityToDraftFormValueObjectMapper
  #getCurrentUserService
  #invalidParamsError
  #repository
  #userAdCategories
  #userNotLoggedInUserError

  constructor({
    fromDraftEntityToDraftFormValueObjectMapper,
    getCurrentUserService,
    invalidParamsError,
    repository,
    userAdCategories,
    userNotLoggedInUserError
  }) {
    super()
    this.#fromDraftEntityToDraftFormValueObjectMapper = fromDraftEntityToDraftFormValueObjectMapper
    this.#getCurrentUserService = getCurrentUserService
    this.#invalidParamsError = invalidParamsError
    this.#repository = repository
    this.#userAdCategories = userAdCategories
    this.#userNotLoggedInUserError = userNotLoggedInUserError
  }

  static create({config}) {
    return new GetEmptyAdAdPublisherUseCase({
      fromDraftEntityToDraftFormValueObjectMapper: FormMappersFactory.fromDraftEntityToDraftFormValueObject({config}),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      invalidParamsError: InvalidParamsSharedError.create,
      repository: DraftRepositoriesFactory.hTTPDraftRepository({config}),
      userAdCategories: Object.values(config.get('seller').USER_AD_CATEGORIES),
      userNotLoggedInUserError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  @tracer({metric: 'GetEmptyAdAdPublisherUseCase#execute'})
  @AsyncInlineError()
  async execute({categoryId}) {
    if (!this.#userAdCategories.includes(categoryId)) {
      return Promise.reject(
        this.#invalidParamsError(`[GetEmptyAdAdPublisherUseCase#execute] Unknown category ${categoryId}`)
      )
    }

    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity) {
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: '[GetEmptyAdAdPublisherUseCase#execute] User not logged in'
        })
      )
    }

    const [error, userAdEntity] = await this.#repository.getAdIdByCategory({categoryId, userEntity})

    if (error) return Promise.reject(error)

    const data = this.#fromDraftEntityToDraftFormValueObjectMapper
      .setParams({id: userAdEntity.getAdId(), images: [], userId: userEntity.getId()})
      .map()
      .toJSON()

    return {data}
  }
}

export const factory = GetEmptyAdAdPublisherUseCase.create
